import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { applyBrandedPdfChrome, exportNodeAsBrandedPNG } from '../../branding/exportBranding';

export async function exportParetoChartAsPNG(chartRef) {
  if (!chartRef.current) return;
  await exportNodeAsBrandedPNG(chartRef.current, 'pareto-chart');
}

export function exportParetoTableAsCSV(paretoData) {
  const csvRows = [
    ['Step Number', 'Total Count', 'Fail Count', 'Fail Percentage', 'Cumulative Percentage'],
    ...paretoData.map((data) => [
      data.stepNumber,
      data.totCount || 0,
      data.failCount || 0,
      Number(data.failPercentage || 0).toFixed(2) + '%',
      Number(data.cumulativePercentage || 0).toFixed(2) + '%',
    ]),
  ];
  const csvContent = csvRows.map((row) => row.join(',')).join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'pareto_data.csv';
  link.click();
  URL.revokeObjectURL(link.href);
}

export function exportParetoTableAsPDF(paretoData) {
  const doc = new jsPDF();
  const tableColumn = ['Step Number', 'Total Count', 'Fail Count', 'Fail Percentage', 'Cumulative Percentage'];
  const tableRows = paretoData.map((data) => [
    data.stepNumber,
    data.totCount || 0,
    data.failCount || 0,
    Number(data.failPercentage || 0).toFixed(2) + '%',
    Number(data.cumulativePercentage || 0).toFixed(2) + '%',
  ]);

  doc.text('Pareto Failure Analysis', 14, 15);
  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 20,
  });
  applyBrandedPdfChrome(doc, { title: 'Pareto Failure Analysis' });
  doc.save('pareto_data.pdf');
}
